"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStUser = exports.preFightTry = exports.getDeviceInfo = exports.formatAdData = exports.getAds = exports.getErrorMessage = exports.fetchTimeout = void 0;
const js_md5_1 = __importDefault(require("js-md5"));
const type_1 = require("../type");
const logger_1 = require("./logger");
const tools_1 = require("./tools");
const E_NATIVE_QQ_TYPE = 2;
const E_NATIVE_WEIXIN_TYPE = 3;
const fetchTimeout = (fecthPromise, timeout = 5000) => {
    let timeId;
    const abortPromise = new Promise((resolve) => {
        timeId = setTimeout(() => {
            resolve({
                code: 504,
                message: '请求超时！',
            });
        }, timeout);
    });
    const resultPromise = Promise.race([fecthPromise, abortPromise]);
    return resultPromise.then((res) => {
        clearTimeout(timeId);
        return res.json();
    });
};
exports.fetchTimeout = fetchTimeout;
const getErrorMessage = (err) => err.message || err.stack || JSON.stringify(err);
exports.getErrorMessage = getErrorMessage;
const getAds = (params, env) => __awaiter(void 0, void 0, void 0, function* () {
    const startTime = Date.now();
    try {
        const reqObj = makeGetBatchAdsReq(params);
        const reqData = {
            vReqItem: reqObj.vReqItem,
            stAdsUserInfo: reqObj.stAdsUserInfo,
        };
        const requestUrl = env;
        const res = yield (0, exports.fetchTimeout)(fetch(requestUrl, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(reqData),
        }), 16000);
        return (0, exports.formatAdData)(res);
    }
    catch (err) {
        (0, logger_1.logInfo)('REQUEST_ADS_FAIL', JSON.stringify({ msg: (0, exports.getErrorMessage)(err) }));
    }
    finally {
        (0, logger_1.logInfo)('REQUEST_ADS_FINALLY', JSON.stringify({ cost_time: Date.now() - startTime }));
    }
    return [];
});
exports.getAds = getAds;
const formatAdData = (res) => {
    const { vRespItem = {} } = res || {};
    const posIdArr = [];
    const adsArr = vRespItem.reduce((acc, item) => {
        var _a;
        if ((_a = item.vComAdsData) === null || _a === void 0 ? void 0 : _a.length) {
            acc.push(...item.vComAdsData);
            for (let i = 0; i < item.vComAdsData.length && item.stAdsPosKey; i++) {
                posIdArr.push(item.stAdsPosKey.iPosId || 0);
            }
        }
        return acc;
    }, []);
    if (adsArr.length === 0) {
        return [];
    }
    return adsArr
        .map(({ stAdsAdDataComm, stAdsAdDataUI }, index) => {
        if (!stAdsAdDataComm || !stAdsAdDataComm.eAdUIType || !stAdsAdDataUI)
            return undefined;
        const stAdsCommodityInfo = stAdsAdDataUI.stAdsCommodityInfo || {};
        const mAdsCommodityInfoExt = stAdsCommodityInfo.mAdsCommodityInfoExt || {};
        stAdsCommodityInfo.mAdsCommodityInfoExt = (0, tools_1.formatDataNoSlice)(stAdsCommodityInfo.mAdsCommodityInfoExt);
        const adExtInfo = {
            adsFreeMinutes: mAdsCommodityInfoExt.AdsFreeMinutes,
            afterAdsCount: mAdsCommodityInfoExt.AfterAdsCount,
            minSeconds: mAdsCommodityInfoExt.MinSeconds,
            maxAdsPerDay: mAdsCommodityInfoExt.MaxAdsPerDay,
            novelGenuineGuide: mAdsCommodityInfoExt.novelGenuineGuide,
            chapterFree_N: mAdsCommodityInfoExt.ChapterFree_N,
            chapterFree_X: mAdsCommodityInfoExt.ChapterFree_X,
            ChapterFree_MinSeconds: mAdsCommodityInfoExt.ChapterFree_MinSeconds,
        };
        return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, tools_1.formatData)(stAdsAdDataComm)), (0, tools_1.formatData)(stAdsAdDataUI.stAdsAppInfo)), (0, tools_1.formatData)(stAdsAdDataUI.stAdsVideoInfoEx)), adExtInfo), { posId: posIdArr[index] }), (0, tools_1.formatData)(stAdsAdDataUI.stAdsCommodityInfo));
    })
        .filter((item) => !!item);
};
exports.formatAdData = formatAdData;
const makeGetBatchAdsReq = (params) => {
    const { adCount, appId, posId, qaid = '', apn = '0', readerJsVer = '', sQbid, amsSdkInfo, androidId, imei } = params;
    const connectType = (0, tools_1.getConnetType)(apn) || apn;
    const { sGuid, sUserAgent, sQUA, eIdType, sUid, sUidToken } = params.stUser;
    const kdQUA = '';
    const item = {
        stAdsPosKey: {
            iAppId: appId,
            iPosId: posId,
            sKeyWord: '',
        },
        iAdCount: adCount || 1,
    };
    const vReqItem = [item];
    const finalAmsSdkInfo = amsSdkInfo;
    return {
        stAdsUserInfo: {
            sGuid,
            sQua: sQUA || kdQUA,
            sUserIp: params.stUser.sIP || '',
            sAPN: connectType,
            sIMEI: '',
            sLocation: '',
            sBrand: '',
            sDpi: '',
            sAndroidId: '',
            sMacAddr: '',
            sFeedsVersion: readerJsVer,
            sUA: sUserAgent,
            sIdfa: '',
            sQAID: qaid,
            sQbId: sQbid,
            lQQ: eIdType === E_NATIVE_QQ_TYPE ? parseInt(sUid, 10) : 0,
            stOpenId: eIdType === E_NATIVE_WEIXIN_TYPE
                ? { sOpenId: sUid, sAccessToken: sUidToken }
                : { sOpenId: '', sAccessToken: '' },
            mExtendUserInfo: {
                sdk_info_req: finalAmsSdkInfo,
                md5_imei: imei !== '' && imei ? (0, js_md5_1.default)(imei) : '',
                md5_androidid: androidId !== '' && androidId ? (0, js_md5_1.default)(androidId) : '',
                md5_idfa: '',
            },
        },
        vReqItem,
    };
};
const getDeviceInfo = () => new Promise((resolve, reject) => {
    var _a;
    (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.app.getBrowserParam((succCallback) => resolve(succCallback), (errCallback) => reject(errCallback));
});
exports.getDeviceInfo = getDeviceInfo;
const preFightTry = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { type = '', uin = '', skey = '', qbid = '', appid = '', token = '' } = yield (0, tools_1.getLoginData)();
        return {
            type,
            uin,
            skey,
            qbid,
            appid,
            token,
        };
    }
    catch (e) {
        return {};
    }
});
exports.preFightTry = preFightTry;
const getStUser = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { type = '', uin = '', skey = '', qbid = '', appid = '', token = '' } = yield (0, exports.preFightTry)();
        const { guid = '', qua = '', qua2 = '', ua = window.navigator.userAgent } = yield (0, exports.getDeviceInfo)();
        const stUser = {
            sGuid: guid || '',
            sQbid: qbid || '',
            sUid: uin || '',
            eIdType: type_1.EIDType.E_NATIVE_GUID_TYPE,
            sQUA: qua2 || qua || '',
            sUserAgent: ua || '',
            sIP: '',
            eToken: type_1.ENOVELTOKENTYPE.E_NOVEL_TOKEN_UNKNOWN,
            eUsrType: type_1.EUserFromType.E_USERFROME_WEB,
        };
        if (type === type_1.UserTypeEnum.WECHAT) {
            stUser.eIdType = type_1.EIDType.E_NATIVE_WEIXIN_TYPE;
            stUser.sUidToken = token || '';
            stUser.eToken = type_1.ENOVELTOKENTYPE.E_NOVEL_TOKEN_ACCESS;
        }
        else if (type === type_1.UserTypeEnum.QQ) {
            stUser.eIdType = type_1.EIDType.E_NATIVE_QQ_TYPE;
            stUser.sUidToken = skey || '';
            stUser.eToken = type_1.ENOVELTOKENTYPE.E_NOVEL_TOKEN_SKEY;
        }
        else if (type === type_1.UserTypeEnum.QQCONNECT) {
            stUser.eIdType = type_1.EIDType.E_NATIVE_QQ_OPEN_TYPE;
            stUser.sUidToken = '';
            stUser.eToken = type_1.ENOVELTOKENTYPE.E_NOVEL_TOKEN_QQ_ACCESS;
            stUser.sAppID = appid || '';
        }
        else if (type === type_1.UserTypeEnum.PHONE) {
            stUser.eIdType = type_1.EIDType.E_NATIVE_PHONE_TYPE;
            stUser.sUidToken = token || '';
            stUser.eToken = type_1.ENOVELTOKENTYPE.E_NOVEL_TOKEN_PHONE_ACCESS;
            stUser.sAppID = appid || '';
        }
        return stUser;
    }
    catch (err) {
        (0, logger_1.logInfo)('GET_GETSTUSER_ERR0R', JSON.stringify(err));
        (0, tools_1.showToast)('GET_GETSTUSER_ERR0R');
        return {};
    }
});
exports.getStUser = getStUser;
//# sourceMappingURL=getAds.js.map